module.exports = __webpack_public_path__ + "static/img/li_3.b172eb9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/li_3.jpeg
// module id = 1+Hw
// module chunks = 6